export default __webpack_public_path__ + "static/media/front.9202f6c8.jpg";